import { EmptyStateComponent } from '@components/shared/empty-state/empty-state.component';
import { FlatInfoComponent } from '@components/shared/flat-info/flat-info.component';
import { TranslateModule } from '@ngx-translate/core';
import { format } from 'date-fns';
import { BadgeModule } from 'primeng/badge';
import { TableModule } from 'primeng/table';
import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { DepartureRow } from '../../models/arrival-departure.model';

@Component({
  selector: 'app-departures-table',
  standalone: true,
  imports: [CommonModule, TableModule, BadgeModule, TranslateModule, FlatInfoComponent, EmptyStateComponent],
  template: `
    @if (departures && departures.length > 0) {
      <p-table
        [value]="departures"
        [stripedRows]="true"
        styleClass="p-datatable-sm"
        responsiveLayout="scroll"
      >
        <ng-template pTemplate="header">
          <tr>
            <th style="vertical-align: middle">{{ 'arrivalDeparture.flat' | translate }}</th>
            <th style="vertical-align: middle">{{ 'arrivalDeparture.checkInDate' | translate }}</th>
            <th style="vertical-align: middle">{{ 'arrivalDeparture.checkOutDate' | translate }}</th>
            <th style="vertical-align: middle">{{ 'arrivalDeparture.hasCheckedOut' | translate }}</th>
          </tr>
        </ng-template>
        <ng-template
          pTemplate="body"
          let-departure
        >
          <tr>
            <td>
              <app-flat-info [flatInfo]="departure.flatInfo"></app-flat-info>
            </td>
            <td>{{ formatDate(departure.checkInDate) }}</td>
            <td>{{ formatDate(departure.checkOutDate) }}</td>
            <td>
              <i [ngClass]="departure.hasCheckedOut ? 'pi pi-check-circle text-green-500' : 'pi pi-times-circle text-red-500'"></i>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="4">
              <app-empty-state [title]="'arrivalDeparture.noDepartures'"></app-empty-state>
            </td>
          </tr>
        </ng-template>
      </p-table>
    } @else {
      <app-empty-state [title]="'arrivalDeparture.noDepartures'"></app-empty-state>
    }
  `
})
export class DeparturesTableComponent {
  @Input() departures: DepartureRow[] = [];

  constructor() {}

  /**
   * Format date to display in table
   */
  formatDate(date: Date): string {
    return format(date, 'yyyy-MM-dd');
  }
}
